import { acceptHMRUpdate, defineStore, storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useAuthStore } from './auth'
import type { TOrganization } from '@/models'

const permissions = {
  canSeeAllRequests: 'RapiHogarWeb.view_all_requests_of_my_organization', // PRODU?? ver solo solicitudes de mi subsidiaria LOCAL ver todas las solicitudes de mi organizacion
  canSeeMyRequests: 'RapiHogarWeb.view_only_my_requests', // PRODU?? ver mis pedidos asignados LOCAL ver solo mis solicitudes
  canCreateRequests: 'RapiHogarWeb.add_pedido', // PRODU LOCAL can add pedido EN ORGANIZACION Crear pedidos corpo
  canCreateAssistanceRequests: 'RapiHogarWeb.can_create_corpo_assistance_request', // PRODU LOCAL Puede crear pedidos de asistencia desde corpo
  canSeeChatRequests: 'RapiHogarWeb.view_chat', // PRODU LOCAL ver los chats de los pedidos
  canSeeInboxNotification: 'RapiHogarWeb.view_notification', // PRODU LOCAL Can view notification
  canChangeRequestResponsible: 'RapiHogarWeb.assign_a_user_to_the_request', // PRODU LOCAL asignar un usuario de la organización al pedido NO SE USA
  canHandleBudgets: 'approve_budgets', // PRODU LOCAL aprobar presupuestos NO SE USA
  canSeeOnlyAssists: 'RapiHogarWeb.view_only_assists', //PRODU Ver pedidos del esquema Asistencia LOCAL ver solo las Asistencias
  canSeeOnlyClaims: 'RapiHogarWeb.view_only_siniestros', // PRODU Ver pedidos del esquema Siniestros LOCAL ver solo los siniestros
  canSeeOnlyGruas: 'RapiHogarWeb.ver_solo_esquema_gruas', // PRODU LOCAL ver pedidos del esquema Gruas
  canSeeOnlyAsistenciaVehicular: 'RapiHogarWeb.ver_solo_esquema_asistencia_vehicular', // ver pedidos del esquema Asistencia Vehicular
  canSeeOnlyReintegro: 'RapiHogarWeb.ver_solo_esquema_reintegro', // PRODU LOCAL ver pedidos de esquemas Reintegro
  canSeeOnlyTrash: 'RapiHogarWeb.ver_solo_esquema_trash', // PRODU LOCAL ver pedidos del esquema Trash
  canSeeOnlyCristales: 'RapiHogarWeb.ver_solo_esquema_cristales', // PRODU LOCAL ver pedidos del esquema Cristales
  canSeeOnlyTelemedicina: 'RapiHogarWeb.ver_solo_esquema_telemedicina', // PRODU LOCAL ver pedidos del esquema Telemedicina
  canSeeOnlyLiquidacion: 'RapiHogarWeb.ver_solo_esquema_liquidacion', // PRODU LOCAL ver pedidos del esquema Liquidacion
  canAddClient: 'RapiHogarWeb.add_cliente', // PRODU LOCAL Can add cliente
  canSeeStatistics: 'RapiHogarWeb.can_see_statistics', // PRODU LOCAL puede ver estadísticas EN ORGANIZACION Show corpo stats = true
  canSeeStatisticsresults: 'RapiHogarWeb.can_see_statistics_results', // PRODU Puede ver resultados de estadisticas LOCAL can see statistics results
  canSeeStatisticsmanagementtimes: 'RapiHogarWeb.can_see_statistics_management_times', // PRODU Puede ver tiempos de gestión de estadísticas LOCAL can see statistics management times
  canSeeStatisticsnps: 'RapiHogarWeb.can_see_statistics_nps', // PRODU Puede ver estadisticas nps LOCAL can see statistics nps
  canSeeStatisticsmetrics: 'RapiHogarWeb.can_see_statistics_call_metrics', // PRODU Puede ver métricas de llamadas de estadísticas LOCAL can see statistics call metrics
  canSeeStatisticsorders: 'RapiHogarWeb.can_see_statistics_raw_orders', // PRODU Puede ver pedidos en bruto de estadisticas LOCAL can see statistics raw orders
  canSeeStatisticspolicies: 'RapiHogarWeb.can_see_statistics_raw_policies', // PRODU Puede ver pólizas en bruto de estadísticas LOCAL can see estatistics raw policies
  canSeeStatisticsnpsresponses: 'RapiHogarWeb.can_see_statistics_raw_nps_responses', // PRODU Puede ver todas las preguntas de NPS en bruto LOCAL can see statistics raw nps responses
  canSeeStatisticsrawnpsanswers: 'RapiHogarWeb.can_see_statistics_raw_nps_answers', // PRODU Puede ver puntaje NPS en bruto LOCAL can see statistics raw nps answers
  canSeeStatisticsbasenpsgalicia: 'RapiHogarWeb.can_see_statistics_base_nps_galicia', // PRODU Puede ver estadísticas de Base Encuestas NPS
  canSeeStatisticspedidosgruas: 'RapiHogarWeb.can_see_statistics_pedidos_gruas', // PRODU Puede ver estadisticas de Pedidos de Gruas
  canSeeStatisticsusuariosrecurrentes: 'RapiHogarWeb.can_see_statistics_usuarios_recurrentes', // PRODU Puede ver estadisticas de Usuarios Recurrentes
  canSeeStatisticsgestionreintegros: 'RapiHogarWeb.can_see_statistics_gestion_reintegros', // PRODU Puede ver estadisticas de Gestion Reintegros
  canSeeStatisticsbasenpsbbva: 'RapiHogarWeb.can_see_statistics_base_nps_bbva', // PRODU puede ver estadísticas de Base Encuesta NPS BBVA

  canSeeAssistanceChat: 'RapiHogarWeb.can_see_the_chat_for_asistencia_scheme', // PRODU LOCAL Puede chatear para el esquema Asistencias
  canSeeClaimChat: 'RapiHogarWeb.can_see_the_chat_for_siniestros_scheme', // PRODU LOCAL Puede chatear para el esquema Siniestros
  canSeeRefundChat: 'RapiHogarWeb.can_see_the_chat_for_reintegro_scheme', // PRODU LOCAL Puede chatear para el esquema Reintegro
  canCreateSubscription: 'RapiHogarWeb.add_subscription', // PRODU LOCAL Can add subscription
  canSeeSubscription: 'RapiHogarWeb.view_subscription', // PRODU LOCAL Can view subscription
  canCreateSiniestrosRequests: 'RapiHogarWeb.can_create_corpo_siniestro_request', // PRODU LOCAL Puede crear pedidos de siniestros desde corpo
  canManageTeam: 'RapiHogarWeb.can_edit_team_on_corpo', // PRODU LOCAL Puede editar un equipo desde corpo

  canAddSubscriptionCobroexpress: 'RapihogarWeb.add_subscriptioncobroexpress', // PRODU LOCAL Can add subscription cobro express
  canAddSubscriptionPagoTic: 'RapihogarWeb.add_subscriptionpagotic', // PRODU LOCAL Can add subscription pago tic
  canSeeStatisticsCanalVentaNx: 'RapiHogarWeb.can_see_statistics_canal_venta_nx', // PRODU LOCAL Solo puede ver estadisticas de Canal de Venta Nx
  canSeeStatisticsProductsAnswer: 'RapiHogarWeb.can_see_statistics_products_answer', // PRODU LOCAL Solo puede ver estadisticas de Answer
} as const

type PermissionsType = keyof typeof permissions

export const usePermissions = defineStore('permissions', () => {
  const auth = useAuthStore()
  const { user, organization } = storeToRefs(auth)

  const currentUserPermissions = computed(() => {
    return user.value?.permissions ?? []
  })

  const userPermissions = computed(() => {
    const tempPermissions: Record<PermissionsType, boolean> = {} as Record<PermissionsType, boolean>

    Object.entries(permissions).forEach(([key, permission]) => {
      const orgCondition = getOrganizationCondition(key, organization.value)

      tempPermissions[key as PermissionsType] =
        searchPermission(currentUserPermissions.value, permission) && orgCondition
    })

    return tempPermissions
  })

  const userHasMultipleSchemes = computed(() => {
    const schemePermissions = [
      permissions.canSeeOnlyAssists,
      permissions.canSeeOnlyClaims,
      permissions.canSeeOnlyGruas,
      permissions.canSeeOnlyAsistenciaVehicular,
      permissions.canSeeOnlyReintegro,
      permissions.canSeeOnlyTrash,
      permissions.canSeeOnlyCristales,
      permissions.canSeeOnlyTelemedicina,
      permissions.canSeeOnlyLiquidacion,
    ]

    const filtered = schemePermissions.filter(Boolean)
    return filtered.length > 1
  })

  return {
    userPermissions,
    userHasMultipleSchemes,
  }
})

function getOrganizationCondition(permissionKey: string, organization: TOrganization | null): boolean {
  const conditions: Record<string, boolean> = {
    canCreateRequests: !!organization?.canCreateRequest,
    canSeeStatistics: !!organization?.showCorpoStats,
  }
  return conditions[permissionKey] ?? true
}

function searchPermission(permissionList: string[], permission: string): boolean {
  return permissionList.map((p) => p.toLowerCase()).includes(permission.toLowerCase())
}

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(usePermissions, import.meta.hot))
}
